import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import useUserStore from "../stores/useUserStore";
import LiveClassApi from "../api/services/LiveClassApi";
import BackButton from "../components/microComponents/BackButton";
import Skeleton from "react-loading-skeleton";
import ytLogo from "../assets/yt-logo.png";
import moment from "moment";

const LiveClassList = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [liveClassList, setLiveClassList] = useState<any[]>([]);

  useEffect(() => {
    fetchApiData();
  }, []);

  const fetchApiData = () => {
    setIsLoading(true);

    LiveClassApi.getLiveClassList({
      onSuccess: (response) => {
        // console.log("response", response);
        setIsLoading(false);
        setLiveClassList(response.data);
      },
      onError: () => setIsLoading(false),
    });
  };

  const skeleton = (
    <div className="liveClassList_main">
      <div className="liveClassList">
        {Array.from({ length: 10 }).map((_, index) => (
          <div className="item_col" key={index}>
            <div className="liveClassList_item">
              <Skeleton height={50} width={50} className="img" />

              <div className="info">
                <span className="item_name">
                  <Skeleton width={`80%`} />
                </span>
                <div className="image">
                  <Skeleton width={100} height={12} />
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );

  return (
    <div className="Container pb-4" style={{ minHeight: "50vh" }}>
      <div className="home_container">
        <BackButton title={"Chapters"} isSticky={true} />

        {isLoading ? (
          skeleton
        ) : (
          <div className="liveClassList_main">
            <div className="liveClassList">
              {liveClassList.map((item) => (
                <div className="item_col" key={item.id}>
                  <div
                    // state={{
                    //   chapterName: item?.chapter_name_italian,
                    //   introduction: item?.introduction,
                    // }}
                    // onClick={() => onChapterClick(item)}
                    className="liveClassList_item"
                    onClick={() => navigate(`${item.url}`)}
                    style={{ cursor: "pointer" }}
                  >
                    <img className="img" src={ytLogo} alt="back arrow" />
                    <div className="info">
                      <span className="item_name">{item?.title}</span>
                      <div className="image">
                        <span>{moment.utc(item?.updated_at).fromNow()}</span>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default LiveClassList;
